import React from "react";

/**
 * Reusable read-only detail field component for popups, cards, and detail views.
 *
 * @param {Object} props
 * @param {string|React.ReactNode} props.label - The field label displayed above the value box
 * @param {string|number|React.ReactNode} props.value - The text or node displayed inside the value box
 * @param {"ltr"|"rtl"|string} [props.dir] - Text direction override (e.g. "ltr" for shipment numbers/English text)
 * @param {React.ReactNode} [props.action] - Optional action element on the side (copy button, view icon, etc.)
 * @param {boolean} [props.isMultiLine=false] - Whether to preserve line breaks and adjust line height
 * @param {string} [props.className="mb-3"] - Optional extra class names for the outer container
 * @param {Object} [props.style] - Optional inline style for the outer container
 * @param {Object} [props.boxStyle] - Optional inline style for the inner box
 * @param {Object} [props.valueStyle] - Optional inline style for the value span
 */
const DetailField = ({
    label,
    value,
    dir,
    action,
    isMultiLine = false,
    className = "mb-3",
    style = {},
    boxStyle = {},
    valueStyle = {},
}) => {
    if (!value && value !== 0) return null;

    return (
        <div className={className} style={style}>
            {!!label && (
                <label
                    className="d-block mb-1"
                    style={{ fontSize: "14px", fontWeight: "500", color: "#333" }}
                >
                    {label}
                </label>
            )}
            <div
                className="d-flex justify-content-between align-items-center"
                style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    padding: "12px 16px",
                    backgroundColor: "#fff",
                    minHeight: "46px",
                    gap: "12px",
                    ...boxStyle,
                }}
            >
                <span
                    dir={dir}
                    style={{
                        fontSize: "14px",
                        color: "#212529",
                        direction: dir || "inherit",
                        wordBreak: "break-word",
                        whiteSpace: isMultiLine ? "pre-line" : "normal",
                        lineHeight: isMultiLine ? "1.4" : "normal",
                        display: "inline-block",
                        width: "100%",
                        ...valueStyle,
                    }}
                >
                    {value}
                </span>
                {action}
            </div>
        </div>
    );
};

export default DetailField;
